// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-tasklist-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  color: white;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 40px);
}

.tasklist-controls {
  margin-bottom: 20px;
}

.list-name-input {
  padding: 8px 12px;
  font-size: 18px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 300px;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}

.tasklist-header {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;
}

.tasklist-content {
  min-height: 200px;
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
}

.tasklist-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  min-height: 100px;
  flex-grow: 1;
}

.tasklist-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: border-color 0.2s;
  margin: 4px 0;
}

.tasklist-item:hover {
  border-color: rgba(255, 255, 255, 0.2);
}

.tasklist-item.is-dragging {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  transform: scale(1.02);
}

.tasklist-item.section {
  margin-left: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.tasklist-item.subsection {
  margin-left: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.tasklist-item.item {
  margin-left: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.drag-handle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: grab;
  color: #666;
  transition: color 0.2s;
}

.drag-handle:active {
  cursor: grabbing;
  color: #333;
}

.drag-handle svg {
  width: 16px;
  height: 16px;
}

.tasklist-input {
  flex: 1 1;
  border: none;
  background: transparent;
  color: inherit;
  padding: 4px 8px;
  font-size: inherit;
  outline: none;
  width: 100%;
}

.tasklist-input::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.tasklist-input:focus {
  outline: none;
  background: transparent;
}

.add-buttons-container {
  display: flex;
  gap: 10px;
  margin: 20px 0;
  flex-wrap: wrap;
}

.add-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s;
  color: white;
}

.add-btn.section {
  background-color: rgba(76, 175, 80, 0.2);
  color: #388e3c;
}

.add-btn.section:hover {
  background-color: rgba(76, 175, 80, 0.3);
}

.add-btn.subsection {
  background-color: rgba(76, 175, 80, 0.2);
  color: #388e3c;
}

.add-btn.subsection:hover {
  background-color: rgba(76, 175, 80, 0.3);
}

.add-btn.item {
  background-color: rgba(76, 175, 80, 0.2);
  color: #388e3c;
}

.add-btn.item:hover {
  background-color: rgba(76, 175, 80, 0.3);
}

.save-btn {
  display: block;
  width: 100%;
  padding: 12px;
  background-color: #2196f3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  margin-top: 20px;
}

.save-btn:hover {
  background-color: #1976d2;
}

.delete-btn-template {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.3s;
}

.delete-btn-template:hover {
  background-color: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

.font-size-controls {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  padding: 15px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.font-size-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.font-size-control label {
  color: white;
  font-size: 0.9em;
}

.font-size-control input {
  width: 60px;
  padding: 4px 8px;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  color: white;
  text-align: center;
}

.font-size-control span {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9em;
}

.location-selection {
  margin: 20px 0;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
}

.location-selection h3 {
  margin-bottom: 10px;
  color: white;
  margin-top: 0;
}

.location-assignment {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 10px 0;
  max-height: 200px;
  overflow-y: auto;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.location-checkbox {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  min-width: 120px;
  flex: 1 1;
  max-width: calc(50% - 5px);
}

.location-checkbox:hover {
  background-color: #eeeeee;
}

.location-checkbox input {
  margin: 0;
}

.empty-tasklist-message {
  text-align: center;
  padding: 2rem;
  color: #666;
  font-style: italic;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  margin: 1rem 0;
}

.form-section {
  margin-bottom: 20px;
}

.form-section label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
}

.name-input {
  width: 100%;
  padding: 8px 12px;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  color: white;
  font-size: 14px;
}

.name-input:hover {
  border-color: #2196F3;
}

.name-input:focus {
  outline: none;
  border-color: #2196F3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.25);
}

.location-select-container {
  width: 100%;
}

.location-select__control {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  min-height: 38px;
}

.location-select__control:hover {
  border-color: #2196F3 !important;
}

.location-select__menu {
  background-color: #011029 !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
}

.location-select__option {
  background-color: transparent !important;
  color: white !important;
}

.location-select__option--is-focused {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.location-select__multi-value {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.location-select__multi-value__label {
  color: white !important;
}

.location-select__multi-value__remove:hover {
  background-color: rgba(244, 67, 54, 0.2) !important;
  color: #f44336 !important;
}

.location-select__input {
  color: white !important;
}

/* Mobile Styles */
@media screen and (max-width: 768px) {
  .location-assignment {
    flex-direction: column;
  }

  .font-size-controls {
    flex-direction: column;
  }

  .list-name-input {
    width: 100%;
  }
}

/* Override react-select styles for dark theme */
.location-select {
  color: #fff;
}

.select__control {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.select__menu {
  background-color: #011029 !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.select__option {
  background-color: transparent !important;
  color: white !important;
}

.select__option--is-focused {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.select__single-value {
  color: white !important;
}

.select__multi-value {
  background-color: rgba(33, 150, 243, 0.3) !important;
}

.select__multi-value__label {
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/components/forms/CreateTasklist.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;EACjD,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,SAAO;EACP,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,0CAA0C;EAC1C,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,gDAAgD;AAChD;EACE,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".create-tasklist-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  min-height: calc(100vh - 40px);\n}\n\n.tasklist-controls {\n  margin-bottom: 20px;\n}\n\n.list-name-input {\n  padding: 8px 12px;\n  font-size: 18px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  width: 300px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: white;\n}\n\n.tasklist-header {\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.tasklist-content {\n  min-height: 200px;\n  margin: 1rem 0;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  min-height: 0;\n}\n\n.tasklist-items {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 8px;\n  min-height: 100px;\n  flex-grow: 1;\n}\n\n.tasklist-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  border-radius: 4px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  transition: border-color 0.2s;\n  margin: 4px 0;\n}\n\n.tasklist-item:hover {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.tasklist-item.is-dragging {\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n  transform: scale(1.02);\n}\n\n.tasklist-item.section {\n  margin-left: 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.tasklist-item.subsection {\n  margin-left: 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.tasklist-item.item {\n  margin-left: 40px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.drag-handle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  cursor: grab;\n  color: #666;\n  transition: color 0.2s;\n}\n\n.drag-handle:active {\n  cursor: grabbing;\n  color: #333;\n}\n\n.drag-handle svg {\n  width: 16px;\n  height: 16px;\n}\n\n.tasklist-input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  color: inherit;\n  padding: 4px 8px;\n  font-size: inherit;\n  outline: none;\n  width: 100%;\n}\n\n.tasklist-input::placeholder {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.tasklist-input:focus {\n  outline: none;\n  background: transparent;\n}\n\n.add-buttons-container {\n  display: flex;\n  gap: 10px;\n  margin: 20px 0;\n  flex-wrap: wrap;\n}\n\n.add-btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.3s;\n  color: white;\n}\n\n.add-btn.section {\n  background-color: rgba(76, 175, 80, 0.2);\n  color: #388e3c;\n}\n\n.add-btn.section:hover {\n  background-color: rgba(76, 175, 80, 0.3);\n}\n\n.add-btn.subsection {\n  background-color: rgba(76, 175, 80, 0.2);\n  color: #388e3c;\n}\n\n.add-btn.subsection:hover {\n  background-color: rgba(76, 175, 80, 0.3);\n}\n\n.add-btn.item {\n  background-color: rgba(76, 175, 80, 0.2);\n  color: #388e3c;\n}\n\n.add-btn.item:hover {\n  background-color: rgba(76, 175, 80, 0.3);\n}\n\n.save-btn {\n  display: block;\n  width: 100%;\n  padding: 12px;\n  background-color: #2196f3;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  margin-top: 20px;\n}\n\n.save-btn:hover {\n  background-color: #1976d2;\n}\n\n.delete-btn-template {\n  background: none;\n  border: none;\n  color: #666;\n  cursor: pointer;\n  padding: 4px 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.3s;\n}\n\n.delete-btn-template:hover {\n  background-color: rgba(244, 67, 54, 0.1);\n  color: #f44336;\n}\n\n.font-size-controls {\n  display: flex;\n  gap: 15px;\n  flex-wrap: wrap;\n  padding: 15px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n}\n\n.font-size-control {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.font-size-control label {\n  color: white;\n  font-size: 0.9em;\n}\n\n.font-size-control input {\n  width: 60px;\n  padding: 4px 8px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  color: white;\n  text-align: center;\n}\n\n.font-size-control span {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.9em;\n}\n\n.location-selection {\n  margin: 20px 0;\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n}\n\n.location-selection h3 {\n  margin-bottom: 10px;\n  color: white;\n  margin-top: 0;\n}\n\n.location-assignment {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin: 10px 0;\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 10px;\n  background-color: rgba(255, 255, 255, 0.05);\n  border-radius: 4px;\n}\n\n.location-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  cursor: pointer;\n  user-select: none;\n  min-width: 120px;\n  flex: 1;\n  max-width: calc(50% - 5px);\n}\n\n.location-checkbox:hover {\n  background-color: #eeeeee;\n}\n\n.location-checkbox input {\n  margin: 0;\n}\n\n.empty-tasklist-message {\n  text-align: center;\n  padding: 2rem;\n  color: #666;\n  font-style: italic;\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n  margin: 1rem 0;\n}\n\n.form-section {\n  margin-bottom: 20px;\n}\n\n.form-section label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.name-input {\n  width: 100%;\n  padding: 8px 12px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  color: white;\n  font-size: 14px;\n}\n\n.name-input:hover {\n  border-color: #2196F3;\n}\n\n.name-input:focus {\n  outline: none;\n  border-color: #2196F3;\n  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.25);\n}\n\n.location-select-container {\n  width: 100%;\n}\n\n.location-select__control {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  border-color: rgba(255, 255, 255, 0.2) !important;\n  min-height: 38px;\n}\n\n.location-select__control:hover {\n  border-color: #2196F3 !important;\n}\n\n.location-select__menu {\n  background-color: #011029 !important;\n  border: 1px solid rgba(255, 255, 255, 0.2) !important;\n}\n\n.location-select__option {\n  background-color: transparent !important;\n  color: white !important;\n}\n\n.location-select__option--is-focused {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.location-select__multi-value {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.location-select__multi-value__label {\n  color: white !important;\n}\n\n.location-select__multi-value__remove:hover {\n  background-color: rgba(244, 67, 54, 0.2) !important;\n  color: #f44336 !important;\n}\n\n.location-select__input {\n  color: white !important;\n}\n\n/* Mobile Styles */\n@media screen and (max-width: 768px) {\n  .location-assignment {\n    flex-direction: column;\n  }\n\n  .font-size-controls {\n    flex-direction: column;\n  }\n\n  .list-name-input {\n    width: 100%;\n  }\n}\n\n/* Override react-select styles for dark theme */\n.location-select {\n  color: #fff;\n}\n\n.select__control {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  border-color: rgba(255, 255, 255, 0.2) !important;\n}\n\n.select__menu {\n  background-color: #011029 !important;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.select__option {\n  background-color: transparent !important;\n  color: white !important;\n}\n\n.select__option--is-focused {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.select__single-value {\n  color: white !important;\n}\n\n.select__multi-value {\n  background-color: rgba(33, 150, 243, 0.3) !important;\n}\n\n.select__multi-value__label {\n  color: white !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
